import React from 'react';
import Menu from './Menu.js';
import Foot from './Foot.js';
import '../Styles/TermsAndConditions.css';

const TermsAndConditions = () => {

	return (
		<div id="TermsAndCondition-page">
			<header>
				<Menu id="Menu" className="row-container"/>
			</header>
			<main>
				<div id="Terms-and-conditions" className="gutter column-container">
					<h1 className="centered">Terms and Conditions</h1>
					<section className="payment-section">
						<h2>Payment</h2>
						<ul>
							<li>Payments needs to be made as soon as possible, if there is a problem, you can contact me, I am not an ogre</li>
							<li>If you want to pay via EFT, I will send you my banking details</li>
							<li>Please use your instagram name as proof of payment</li>
							<li>The Item will only be sent out after I have received a proof of payment</li>
							<li>Cash on collection is available</li>
						</ul>
					</section>
					<section className="general-section"> 
						<h2> General </h2>
		 				<ul>
							<li>First come first serve</li>
							<li>Unfortunately, no returns, exchanges, or refunds (feel free to contact me if you have any questions about items)</li>
							<li>All sales are final</li>
							<li>If you don't espond in time you will lose the item to someone who is ready to finalise</li>
							<li>Packages will be sent out once a valid proof of payment is presented (allocated 48hours to present it)</li>
							<li>Courier costs are excluded in all pricing. Click <a href="/Courier">here</a> for more information about delivery prices</li>
						</ul>
					</section>
				</div>
			</main>
			<footer className="centered">
				<Foot/>
			</footer>
		</div>
	)
}

export default TermsAndConditions; 